<template>
  <div class="music">
    <div class="btnbox">
      <el-button class="add-btn" icon="el-icon-plus" @click="add"
        >添加音乐</el-button
      >
    </div>
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="musicCover" label="缩略图" min-width="50px">
          <template slot-scope="{ row }">
            <div class="logo">
              <el-image
                :src="row.musicCover"
                :preview-src-list="[row.musicCover]"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="musicName" label="名称"> </el-table-column>
        <el-table-column prop="musicUrl" label="地址">
          <template slot-scope="{ row }">
            <el-button
              class="textBlue-btn"
              slot="reference"
              @click="copyUrl(row.musicUrl)"
              >复制地址</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="musicDurationText" label="时长">
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="120">
          <template slot-scope="scope">
            <el-popconfirm
              title="是否删除该音乐资源吗？"
              popper-class="customerdel-popover"
              @confirm="deleteFn(scope.row.id)"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              class="textBlue-btn"
              type="text"
              @click="checkTest(scope.row)"
              style="margin-left: 5px"
              >试听
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 试听 -->
    <el-dialog
      :visible.sync="testVisible"
      title="试听"
      width="40%"
      :before-close="handletestClose"
      destroy-on-close
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>
          试听
          <span style="color: #483d8b">{{ musicName }}-{{ musicSinger }}</span>
        </p>
        <span @click="handletestClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="audio-box">
        <audio :src="audioUrl" controls ref="audioRef"></audio>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [
        {
          musicSinger: "XJBY",
          musicDuration: 30,
          musicUrl:
            "https://oss.quanjijie.com/audio/71ccd3f4706542ff9c7f834328e63122.mp3",
          musicCover:
            "https://oss.quanjijie.com/rhythm/f37350ff4f1c4f41b417db3aee434b3a.jpg",
          createdTime: "2024-07-18 15:02:13",
          id: 8,
          starLevel: 4,
          status_dictText: "启用",
          totalScore: 680.0,
          musicName: "小城夏天",
          status: 0,
        },
        {
          musicSinger: "Justin",
          musicDuration: 203,
          musicUrl:
            "https://oss.quanjijie.com/audio/67703bfbec344f5c9113b6335145c89c.mp3",
          musicCover:
            "https://oss.quanjijie.com/rhythm/1e0cde2cb3a84414b72c571bfe6911dc.jpg",
          createdTime: "2024-07-11 10:39:54",
          id: 4,
          starLevel: 5,
          status_dictText: "启用",
          totalScore: 300.0,
          musicName: "仙梦寻游",
          status: 0,
        },
        {
          musicSinger: "Black Eyed Peas",
          musicDuration: 213,
          musicUrl:
            "https://oss.quanjijie.com/audio/0c6fe21fbc044b8a9bfe5c5a3e7c27be.mp3",
          musicCover:
            "https://oss.quanjijie.com/rhythm/209249f6bcb64141a9192fe571e0c126.png",
          createdTime: "2024-07-10 15:40:57",
          id: 2,
          starLevel: 3,
          status_dictText: "启用",
          totalScore: 5450.0,
          musicName: "Pump It",
          status: 0,
        },
      ],
      total: 0,
      // 试听
      testVisible: false,
      audioUrl: "",
      musicName: "",
      musicSinger: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取列表
    async init() {
      //   const res = await getDeviceList(this.queryParams);
      //   this.tableData = res.result.records;
      //   this.total = res.result.total;
      this.tableData.map((el) => {
        const m = Math.floor(el.musicDuration / 60);
        const s = Math.floor(el.musicDuration % 60);
        el.musicDurationText = `${m < 10 ? "0" + m : m}:${
          s < 10 ? "0" + s : s
        }`;
      });
    },
    // 删除
    async deleteFn() {
      //   await deleteDevice({ id });
      //   this.$message.success("删除成功");
      //   this.init();
    },
    // 复制
    async copyUrl(url) {
      const textToCopy = url;
      await navigator.clipboard.writeText(textToCopy);
      this.$message.success("复制成功");
    },
    checkTest(row) {
      this.audioUrl = row.musicUrl;
      this.musicName = row.musicName;
      this.musicSinger = row.musicSinger;
      this.testVisible = true;
    },
    handletestClose() {
      this.testVisible = false;
    },
    add() {
      this.$router.push({
        path: "/addmusic",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.music {
  position: relative;
  > .btnbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  ::v-deep .logo {
    display: flex;
    // justify-content: center;
    .el-image {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
  }
  .audio-box {
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: center;
    width: 100%;
    audio {
      width: 100%;
      // height: 56px;
    }
  }
}
</style>
